import { StackLayout } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryDriver = getMasonryDriver({ rootNodeId: 'customer-support$root' });

export const CustomerSupportMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '706px',
      marginBottom: '$two',
    }}
  >
    <MasonryEngine driver={MasonryDriver} />
  </StackLayout>
);
